import script from "./Occurrence.vue?vue&type=script&setup=true&lang=js"
export * from "./Occurrence.vue?vue&type=script&setup=true&lang=js"

import "./Occurrence.vue?vue&type=style&index=0&id=63b00196&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b00196"]])

export default __exports__